import React from 'react';
import classnames from 'classnames';
import JournalDumbView from '../../../../DeviationViews/Dumbo/Journal';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Journal.scss';
const JournalMonoReactView = ({ config: { alignment, link, width: configuredWidth }, settings, deviation })=>{
    let size = {
        width: 389,
        height: 343
    };
    if (alignment !== 'center') {
        size = {
            width: 350,
            height: 313
        };
    }
    // Handle resizing
    size = getSizeForFreeform(size, configuredWidth);
    if (settings && settings.showMediaAlwaysSmall) {
        // https://zpl.io/awYRXAn
        size = {
            width: 180,
            height: 125
        };
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['normal'], alignment && s[alignment], settings && settings.showMediaAlwaysSmall && s['small']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(JournalDumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
JournalMonoReactView.displayName = 'JournalMonoReactView';
export default JournalMonoReactView;

//# sourceMappingURL=Journal.js.map